import { Button } from "@mui/material";
import styled from "@emotion/styled";
import { type SerializedStyles, css } from "@emotion/react";
import { FC } from "react";

// TODO: Need to convert this component like GText

type Props = {
  // For framer
  text?: string;
  url?: string;
  background?: string;
  fontColor?: string;
  fontSize?: number;
  radius?: number;
  style?: any;
  fontFamily?: string;
  ripple?: boolean;
  // For components using this component
  children?: string | JSX.Element | JSX.Element[];
  hasChild?: boolean;
  css?: SerializedStyles;
  className?: string;
  preWaveText?: string;
  shineColor?: string;
  hoverFontColor?: string;
  duration?: number;
  handleClick?: (arg: any) => void;
  handleTextSplit?: () => JSX.Element[] | undefined;
  handleMouseMove?: (arg: any) => void;
};

const btnHoverStyles = css`
  &:hover {
    filter: brightness(0.9);
  }
`;

const Btn = styled(Button)<Props>`
  && {
    background: ${(props) => props.background};
    outline: none;
    box-shadow: none;
    font-size: ${(props) => props.fontSize ?? 16}px;
    text-transform: initial;
    border-radius: ${(props) => props.radius ?? 8}px;
    font-weight: 500;
    font-family: ${(props) => props.fontFamily};
    position: relative;
    color: ${(props) => props.fontColor};

    ${btnHoverStyles};
  }
`;

export const GBtn: FC<Props> = (props) => {
  const {
    handleClick,
    handleMouseMove,
    handleTextSplit,
    preWaveText,
    hasChild,
    ...restProps
  } = props;

  const renderText = () => {
    if (hasChild && props.children) {
      return props.children;
    }

    return preWaveText && handleTextSplit ? handleTextSplit() : props.text;
  };

  return (
    <Btn
      {...restProps}
      variant="contained"
      data-text={preWaveText}
      disableRipple={!props.ripple}
      href={props.url}
      style={props.style}
      css={props.css}
      onClick={handleClick}
      onMouseMove={handleMouseMove}
    >
      {renderText()}
    </Btn>
  );
};

// We need to add the below in framer
/*
addPropertyControls(Button, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    fontColor: {
        title: "Font Color",
        type: ControlType.Color,
        defaultValue: "#fff",
    },
    background: {
        title: "Background",
        type: ControlType.Color,
        defaultValue: "#854DFF",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 16,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
    radius: {
        title: "Radius",
        type: ControlType.Number,
        defaultValue: 8,
    },
    url: {
        title: "URL",
        type: ControlType.Link,
        defaultValue: "Home",
    },
    ripple: {
        title: "Ripple",
        type: ControlType.Boolean,
        description: "Adds a ripple effect on click if true",
        defaultValue: true,
    },
})
*/

export default GBtn;
